import { formatDateTimeWithoutTimezone } from './formatTime';

// Utility to get start and end of a day as timezone-less wall-clock values.
export function getDayRange(date) {
  const d = new Date(date);
  const start = new Date(d.setHours(0, 0, 0, 0));
  const end = new Date(d.setHours(23, 59, 59, 999));
  return {
    startDate: formatDateTimeWithoutTimezone(start),
    endDate: formatDateTimeWithoutTimezone(end),
  };
}

// Utility to get start and end of a week (Sunday to Saturday) as timezone-less wall-clock values.
export function getWeekRange(date) {
  const d = new Date(date);
  const day = d.getDay();
  const diffToSunday = d.getDate() - day;
  const diffToSaturday = d.getDate() + (6 - day);
  const start = new Date(d.setDate(diffToSunday));
  start.setHours(0, 0, 0, 0);
  const end = new Date(d.setDate(diffToSaturday));
  end.setHours(23, 59, 59, 999);
  return {
    startDate: formatDateTimeWithoutTimezone(start),
    endDate: formatDateTimeWithoutTimezone(end),
  };
}

// Utility to convert a visible calendar range into an inclusive timezone-less date window.
export function getVisibleRange(startDate, endDate) {
  const start = new Date(startDate);
  start.setHours(0, 0, 0, 0);

  const end = new Date(endDate);
  end.setMilliseconds(end.getMilliseconds() - 1);

  return {
    startDate: formatDateTimeWithoutTimezone(start),
    endDate: formatDateTimeWithoutTimezone(end),
  };
}
